import { Component, Mixins } from 'vue-property-decorator'
import { email, maxLength, minLength, required, sameAs } from 'vuelidate/lib/validators'
import { Validation, validationMixin } from 'vuelidate'

import type { MailClaimSendBody } from '@/api'

@Component<FeedbackValidations>({
  validations: {
    form: {
      theme_id: {
        required,
      },
      middleName: {
        maxLength: maxLength(60),
      },
      lastName: {
        maxLength: maxLength(60),
        required,
      },
      firstName: {
        maxLength: maxLength(60),
        required,
      },
      message: {
        required,
      },
      email: { email, maxLength: maxLength(50) },
      mobilePhone: { minLength: minLength(18) },
      no_response_required: {
        oneCheckRequired: sameAs(value => {
          if (!value.email_response) {
            return true
          }
          return false
        }),
      },
      email_response: {},
    },
  },
})
export class FeedbackValidations extends Mixins<Validation>(validationMixin) {
  form!: MailClaimSendBody

  get themeErrors() {
    if (!this.$v.form.theme_id.$dirty) return []

    const errors: Array<string> = []
    if (this.$v.form.theme_id.$anyError) errors.push('Поле обязательно для заполнения')
    return errors
  }

  get lastNameErrors() {
    if (!this.$v.form.lastName.$dirty) return []

    const errors: Array<string> = []
    if (this.$v.form.lastName.$anyError) errors.push('Некорректно заполнена Фамилия')
    return errors
  }

  get firstNameErrors() {
    if (!this.$v.form.firstName.$dirty) return []

    const errors: Array<string> = []
    if (this.$v.form.firstName.$anyError) errors.push('Некорректно заполнено Имя')
    return errors
  }

  get middleNameErrors() {
    if (!this.$v.form.middleName?.$dirty) return []

    const errors: Array<string> = []
    if (this.$v.form.middleName?.$anyError) errors.push('Некорректно заполнено Отчество')
    return errors
  }

  get messageErrors() {
    if (!this.$v.form.message.$dirty) return []

    const errors: Array<string> = []
    if (this.$v.form.message.$anyError) errors.push('Поле обязательно для заполнения')
    return errors
  }

  get mobilePhoneErrors() {
    if (!this.$v.form.mobilePhone.$dirty) return []

    const errors: Array<string> = []
    if (this.$v.form.mobilePhone.$anyError) errors.push('Перепроверьте номер')
    return errors
  }

  get mailErrors() {
    if (!this.$v.form.email.$dirty) return []

    const errors: Array<string> = []
    if (!this.$v.form.email.email) errors.push('Неправильный формат почты')
    if (!this.$v.form.email.maxLength) errors.push('Почта должна содержать до 50 символов')
    return errors
  }

  get responseErrors() {
    if (!this.$v.form.no_response_required.$dirty) return []

    const errors: Array<string> = []
    if (this.$v.form.no_response_required.$anyError) errors.push('Обязателен один из ответов')
    return errors
  }
}
